import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { Dispatch, SetStateAction } from "react";
import { StarOutlineIcon } from "../icon/StarOutlineIcon";
import { StarSolidIcon } from "../icon/StarSolidIcon";
import { Body14Regular } from "../typography/Body14Regular";
interface Props {
  isStar: boolean;
  setIsStar: Dispatch<SetStateAction<boolean>>;
}

export const OrderItemFavoriteFilter: React.FC<Props> = ({
  isStar,
  setIsStar,
}) => {
  const handleClick = () => {
    setIsStar(!isStar);
  };

  return (
    <Button
      color={isStar ? ButtonColor.PRIMARY : ButtonColor.WHITE}
      size="sx"
      className={`flex items-center justify-between w-[137px] h-[42px] px-[12px] `}
      onClick={handleClick}
    >
      {isStar ? (
        <StarSolidIcon size={16} className="mr-[8px] mt-[2px]" />
      ) : (
        <StarOutlineIcon size={16} className="mr-[8px] mt-[2px]" />
      )}
      <Body14Regular>즐겨찾기만 보기</Body14Regular>
    </Button>
  );
};
